import AlertasBarredores from "@/views/AlertasBarredores.vue";

const alertasBarredores = {
  path: "/app/alertasBarredores",
  name: "alertasBarredores",
  component: AlertasBarredores,
};

export default alertasBarredores;
